import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=272aa6d2&scoped=true&lang=pug&"
import script from "./EmailInput.vue?vue&type=script&lang=js&"
export * from "./EmailInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272aa6d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('272aa6d2')) {
      api.createRecord('272aa6d2', component.options)
    } else {
      api.reload('272aa6d2', component.options)
    }
    module.hot.accept("./EmailInput.vue?vue&type=template&id=272aa6d2&scoped=true&lang=pug&", function () {
      api.rerender('272aa6d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/forms/EmailInput.vue"
export default component.exports